"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var CovidSuitePromoCheckoutEligibility = function CovidSuitePromoCheckoutEligibility() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.COVID_SUITE_PROMO_ELIGIBILITY_RECEIVED:
      return payload.isOfferEligibleForHub;

    default:
      return state;
  }
};

var _default = CovidSuitePromoCheckoutEligibility;
exports.default = _default;
module.exports = exports.default;